import { render, staticRenderFns } from "./TableRiskAppraisal595.vue?vue&type=template&id=2e250c5c&scoped=true"
import script from "./TableRiskAppraisal595.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal595.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal595.vue?vue&type=style&index=0&id=2e250c5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e250c5c",
  null
  
)

export default component.exports